// removed by extract-text-webpack-plugin
module.exports = {"img":"_3F3bU","annotation":"_3LqHN","magnifier":"_2TMNY"};